import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { setFocus } from "../../../../../misc/tools";
import { DaarcBaseScenario } from "../../../../DaarcBaseScenario";
import { GeneralProceduresCricMainConfig, GeneralProceduresCricPart3Config } from "../GeneralProceduresCricMain";
var currentTool: number = 0;
export default class GeneralProceduresCricPart3 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralProceduresCricPart3Config {
		return this.scenarioConfig.part3Config;
	}
	constructor(private _scenario: DaarcBaseScenario, private onScalpelSelected: () => void, 
														private onSpreaderSelected: () => void,
														private onBougieSelected: () => void, 
														private onEttSelected: () => void, 
														private onSyringeSelected: () => void, 
														private onAbortClicked: () => void, private id: string, private scenarioConfig: GeneralProceduresCricMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;
		this.scenario.uiWrapper.displayCricMakeAttemptUI({
			currentTool: currentTool,
			onMakeAttemptClicked: (selectedToolIndx: number) => {
				currentTool++;
				if(currentTool > 4) {
					currentTool = 4;
				}
				setTimeout(() => {
					setFocus('artifitial-progress-root');
				}, 500);
				switch(selectedToolIndx) {
					case 0:
						context.onScalpelSelected();
						break;
					case 1:
						context.onSpreaderSelected();
						break;
					case 2:
						context.onBougieSelected();
						break;
					case 3:
						context.onEttSelected();
						break;
					case 4: 
						context.onSyringeSelected();
						break;
				}
			},
			onAbortedClicked: () => {
				context.onAbortClicked();
			}
		});

	}
}